import {
  CustomerMedicalCertificateStatus,
  MedicalCertificateCartDocument,
  MedicalCertificateCartQuery,
} from '../graphql'
import useCart from './useCart'

export { CustomerMedicalCertificateStatus as MedicalCertificateStatus }

interface Result {
  loading: boolean
  enabled: boolean
  status: CustomerMedicalCertificateStatus | null
  validityDate?: Date | null
}

const useMedicalCertificate = (): Result => {
  const { cartData, isCartLoading } = useCart<MedicalCertificateCartQuery>(MedicalCertificateCartDocument)

  if (isCartLoading || !cartData) {
    return { loading: true, enabled: false, status: null }
  }

  return {
    loading: false,
    enabled: cartData.cart.medicalCertificateRequired,
    status: cartData.cart.customer?.medicalCertificate?.status ?? null,
    validityDate: cartData.cart.customer?.medicalCertificate?.validityDate
      ? new Date(cartData.cart.customer?.medicalCertificate?.validityDate)
      : null,
  }
}

export default useMedicalCertificate
